import { useSelector } from "react-redux";
import { ReduxStoreState } from "web/redux/store";
import { ActiveFilterSerializer, FilterOptionSerializer } from "web/types/serializers";

interface UseCategoryFilterResult {
    facet: "subcategory" | "category" | "product_type";
    hasMultiple?: boolean;
    options: FilterOptionSerializer[];
    parent?: FilterOptionSerializer;
}

export function useCategoryFilter(): UseCategoryFilterResult {
    const { filters, active_filters: activeFilters } = useSelector(
        (state: ReduxStoreState) => state.filters.data ?? { filters: [], active_filters: [] }
    );

    const categorySection = filters?.find(({ id }) => id === "category");

    if (categorySection) {
        const activeCategory = activeFilters?.find(
            (category) => category.facet === "category"
        ) as ActiveFilterSerializer;

        const hasSubcategories = !!categorySection?.options?.[0].options;

        // Subcategories
        if (activeCategory && hasSubcategories) {
            const category = categorySection?.options?.find(
                (option) => option.id === activeCategory.id
            ) as FilterOptionSerializer;

            return {
                facet: "subcategory",
                hasMultiple: true,
                options: category?.options as FilterOptionSerializer[],
                parent: activeCategory,
            };
        }

        // Category
        return {
            facet: "category",
            hasMultiple: !hasSubcategories,
            options: categorySection?.options as FilterOptionSerializer[],
            parent: activeFilters?.find((category) => category.facet === "product_type"),
        };
    }

    const productTypeSection = filters?.find((filter) => filter.id === "product_type");
    return {
        facet: "product_type",
        options: productTypeSection?.options as FilterOptionSerializer[],
    };
}
